export default "__VITE_ASSET__DsYoRTP2__"